import React from 'react';
import cn from 'classnames';
import { Icon } from '@landing/ui';
import * as styles from './SliderButton.module.scss';

function getProgressIcon(value, max) {
  const progressValue = !max || !value ? 0 : (value / max) * 100;

  return (
    <svg
      width="40"
      height="40"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 108 108"
      style={{
        display: 'block',
        transform: 'rotate(90deg) scaleX(-1)',
      }}
    >
      <circle
        r="50"
        cy="54"
        cx="54"
        style={{
          strokeWidth: '2px',
          stroke: '#17161E',
        }}
        fill="currentColor"
      ></circle>
      <circle
        className={styles.circle}
        r="50"
        fill="transparent"
        cy="54"
        cx="54"
        style={{
          strokeWidth: '5px',
          stroke: '#feda00',
          strokeDasharray: 314.159,
          strokeDashoffset: `${2 * 3.14 * 50 * ((100 + progressValue) / 100)}`,
        }}
      ></circle>
      <g
        style={{
          transform: `rotate(${360 * (-progressValue / 100)}deg)`,
          transformOrigin: 'center center',
        }}
        fill="transparent"
      >
        <circle r="50" cy="54" cx="54" fill="transparent"></circle>
      </g>
    </svg>
  );
}

export function SliderButton({ className, back, value, max, handleClick }) {
  return (
    <button
      className={cn(className, styles.wrapper)}
      onClick={handleClick}
      aria-label="Slider button"
    >
      <div className={styles.item}>
        <div className={styles.progressDataWrapper}>
          {getProgressIcon(value, max)}
          <Icon className={cn(styles.arrowIcon, back && styles.back)} name="arrow" />
        </div>
      </div>
    </button>
  );
}
